// Helpers for prefixing challenge notifications with the date they were sent.

// "Venerdì 10 luglio" — Italian weekday + day + month (no year), first letter
// capitalized. Returns "" for missing/invalid input.
export const italianSentDatePrefix = (sentAt) => {
  if (!sentAt) return "";
  const date = new Date(sentAt);
  if (Number.isNaN(date.getTime())) return "";
  const d = date.toLocaleDateString("it-IT", {
    weekday: "long",
    day: "numeric",
    month: "long",
  });
  return d.charAt(0).toUpperCase() + d.slice(1);
};

// Prepend the send-date prefix to a challenge notification body:
// "Venerdì 10 luglio | <body>". Falls back to the original body when the date
// is missing/invalid or the body is empty.
export const withChallengeDatePrefix = (body, sentAt) => {
  const text = body || "";
  if (!text) return text;
  const prefix = italianSentDatePrefix(sentAt);
  return prefix ? `${prefix} | ${text}` : text;
};
